import cookies from './BaseCookies';

const GetCookie = (cookie) =>{
    return cookies.get(cookie);
}

export default GetCookie;